import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

import {
  DayjsDateAdapter,
  MAT_DAYJS_DATE_ADAPTER_OPTIONS,
  MAT_DAYJS_DATE_FORMATS
} from '@shared/utils/dayjs-adapter';

export const MATERIAL_PROVIDERS = [
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: { autoFocus: 'false' }
  },
  {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: { duration: 5000 }
  },
  {
    provide: DateAdapter,
    useClass: DayjsDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_DAYJS_DATE_ADAPTER_OPTIONS]
  },
  { provide: MAT_DATE_FORMATS, useValue: MAT_DAYJS_DATE_FORMATS },
  { provide: MAT_DAYJS_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  {
    provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
    useValue: { hideSingleSelectionIndicator: true }
  },
  {
    provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
    useValue: { formFieldAppearance: 'fill' }
  }
];
